

import Event = createjs.Event;

export class SmartfoxEvent extends Event {
    public static CONNECT_START: string = "connectStart";
    public static CONNECT_FAILED: string = "connectFailed";
    public static CONNECT_TIMEOUT: string = "connectTimeout";
    public static CONNECT_SUCCESS: string = "connectSuccess";
    public static CONNECTION_LOST: string = "connectionLost";
    public static JOINED_ROOM: string = "joinedRoom";
    public static GUEST_LOGIN_FAILED: string = "guestLoginFailed";
    public static GUEST_LOGIN_SUCCESS: string = "guestLoginSuccess";
    public static EXTENSION_RESPONSE: string = "extensionResponse";

    public cmdId: string;
    public params: any[];

    constructor(type: string, cmdId: string = "", params: any[] = null, bubbles: boolean = false, cancelable: boolean = false) {
        super(type, bubbles, cancelable);

        this.cmdId = cmdId;
        this.params = params;
    }
}

